module.exports = __webpack_public_path__ + "img/135047-56.e1946fd0.jpg";